import { getAmbassadorCarousel } from './WhatTheyreSayingSliders';
export default {
    init() {
        const carousel = getAmbassadorCarousel();
        if (!carousel) {
            console.warn('UNTUCKit : Module : Ambassadors : carousel not found');
            return;
        }
        carousel.on('moved', () => {
            syncActiveAthlete(carousel.index);
        });
        document.querySelectorAll('.js-ambassadors .js-hover').forEach((hoverEl) => {
            hoverEl.addEventListener('mouseenter', () => {
                setSlide(hoverEl, carousel);
            });
        });
        setInitial(carousel);
    },
};
function setInitial(carousel) {
    const param = new URLSearchParams(window.location.search).get('ambassador');
    if (!param)
        return;
    const target = document.querySelector(`.js-ambassadors .js-hover[data-ambassador="${param.toLowerCase()}"]`);
    if (!target)
        return;
    setSlide(target, carousel);
    scrollToAmbassadors();
}
function syncActiveAthlete(activeIndex) {
    document.querySelectorAll('.js-ambassadors .js-hover').forEach((el) => {
        el.classList.toggle('is-active', el.dataset.index === String(activeIndex));
    });
}
function setSlide(target, carousel) {
    const slideIndex = target.dataset.index;
    if (slideIndex === undefined)
        return;
    carousel.go(Number(slideIndex));
}
function scrollToAmbassadors() {
    const ambassadorsSection = document.querySelector('.js-ambassadors');
    const header = document.querySelector('.js-header');
    if (!ambassadorsSection || !header)
        return;
    window.scrollTo(0, ambassadorsSection.offsetTop - header.offsetHeight);
}
